import { render, staticRenderFns } from "./DiagnosticResultsWarningModal.vue?vue&type=template&id=1cbe6e3f&scoped=true"
import script from "./DiagnosticResultsWarningModal.vue?vue&type=script&lang=js"
export * from "./DiagnosticResultsWarningModal.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticResultsWarningModal.vue?vue&type=style&index=0&id=1cbe6e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe6e3f",
  null
  
)

export default component.exports